import { render, staticRenderFns } from "./ContributorSearch.vue?vue&type=template&id=348977d2&"
import script from "./ContributorSearch.vue?vue&type=script&lang=js&"
export * from "./ContributorSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports